import {Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {
  ChildFormUpdates,
  VendorCorp,
  ComponentName,
  FormUpdateEvent,
  CreateCustomer
} from "../../../../shared/interfaces";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ApiService} from "../../../../services/api.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {PopUpComponent} from "../../../../util/pop-up/pop-up.component";
import {ToastrService} from "ngx-toastr";
import {ImageCropperComponent} from "../../image-cropper/image-cropper.component";

@Component({
  selector: 'app-create-candidate',
  templateUrl: './create-consultants.component.html',
  styleUrls: ['./create-consultants.component.css']
})
export class CreateConsultantsComponent implements OnInit {
  consultantError = '';
  vendors: VendorCorp;
  consultant: any = {} as any;
  prevLink1;
  prevLink2: string;
  type = '';
  consultantForm: UntypedFormGroup;
  showloader = false;
  logoLoader = false;
  dragOver: boolean = false;
  errorMessage: string | null;
  field = '';
  maximumExperience: any[] = [];
  skills: any[] = [];
  file: File | null;
  doc: File | any;
  size: any;
  length: any;
  notes: any[] = [];
  audit: any[] = [];
  vendorName = '';
  typeId = '';
  vendorId: '';
  visible1 = true;
  visible2 = false;
  currentPage: number = 0;
  totalPages: number;
  orgId: any;
  pageSize = 4;
  status: boolean;
  active = false;
  role: string | null;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLDivElement>;
  consultantImage: string = '';
  consultantLogo: any;
  logoCid: string = '';
  loading = false;
  regex = '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$';
  showArchived: boolean = false;
  consultantDT: any;
  firstName: string = '';
  middleName: string = '';
  lastName: string = '';
  childFormUpdates: ChildFormUpdates = this.initializeChildFormUpdates();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private service: ApiService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<CreateConsultantsComponent>,
  ) {
    this.prevLink1 = 'https://www.'
    this.prevLink2 = 'https://www.'
    this.maximumExperience = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  }

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
    this.consultantDT = this.data.consultantData;
    this.role = localStorage.getItem('role');
    this.orgId = localStorage.getItem('orgId');
    this.typeId = '';
    this.currentPage = 0;
    this.pageSize = 4;
    this.consultantForm = this.fb.group({
      firstName: ['', Validators.required],
    });
    if (this.data.id) {
      this.type = 'edit';
      this.visible1 = false;
      this.visible2 = true;
    } else {
      this.type = 'create';
      this.visible1 = true;
      this.visible2 = false;
    }
  }

  handleConsultantImageChange(event: string) {
    if (event) {
      this.consultantImage = event;
    } else {
      this.consultantImage = '';
      this.consultantDT.profilePicture = '';
    }
  }

  initializeChildFormUpdates(): ChildFormUpdates {
    const updates: ChildFormUpdates = {};
    for (const componentName of Object.values(ComponentName)) {
      updates[componentName] = false;
    }
    return updates;
  }

  handleFormUpdate(event: FormUpdateEvent) {
    this.childFormUpdates[event.componentName] = event.updated;
    if (event.consultheaderDetails) {
      if (this.consultantDT) {
        if (!this.consultantDT.vendor) {
          this.consultantDT.vendor = {};
        }
        this.consultantDT.firstName = event.consultheaderDetails.firstName;
        this.consultantDT.middleName = event.consultheaderDetails.middleName ?? '';
        this.consultantDT.lastName = event.consultheaderDetails.lastName ?? '';
        this.consultantDT.experienceYear = event.consultheaderDetails.experienceYear;
        this.consultantDT.experienceMonth = event.consultheaderDetails.experienceMonth;
        this.consultantDT.title = event.consultheaderDetails.occupation;
        if (event.consultheaderDetails.venderName) {
          this.consultantDT.vendor.vendorName = event.consultheaderDetails.venderName;
        }
      }
    }
  }

  isAllowedFileType(fileType: string): boolean {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    const disallowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    return allowedTypes.includes(fileType) && !disallowedTypes.includes(fileType);
  }

  onSelectLogo(event: any, dragEvent?: boolean): void {
    event.preventDefault();
    this.logoLoader = true;
    this.file = dragEvent ? event.dataTransfer.files[0] : event.target.files?.[0] || null;
    if (!this.file) {
      this.logoLoader = false;
      return;
    }
    if (this.isAllowedFileType(this.file?.type ?? '')) {
      this.openImageCropperDialog(this.file, event);
    } else {
      this.handleUnsupportedFileType(this.file?.type ?? '');
    }
  }

  openImageCropperDialog(file: File, event: any): void {
    const dialogRef = this.dialog.open(ImageCropperComponent, {
      width: '60%',
      data: {file}
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.processCropperResult(result);
      } else {
        this.handleDialogCloseWithoutResult();
      }
      (event.target as HTMLInputElement).value = '';
    });
  }

  processCropperResult(result: any): void {
    if (result.blob instanceof Blob) {
      this.handleBlobResult(result.blob);
    } else if (result.base64) {
      this.handleBase64Result(result.base64);
    } else {
      console.error('Result is not a valid Blob or base64 string:', result);
      this.resetFile();
    }
  }

  handleUnsupportedFileType(fileType: string): void {
    const errorMessage = fileType.includes('pdf') || fileType.includes('doc') ? 'PDF and DOC files are not allowed.' : 'Unsupported file type.';
    console.error(errorMessage);
    this.toastr.error(errorMessage, 'Error');
    this.logoLoader = false;
  }

  handleBlobResult(blob: Blob): void {
    const filename = this.file?.name || 'cropped_image.png';
    const file = new File([blob], filename, {type: blob.type});
    this.uploadFile(file);
  }

  handleBase64Result(base64: string): void {
    const file = this.base64ToFile(base64, this.file?.name || 'cropped_image.png');
    if (file) {
      this.uploadFile(file);
    } else {
      console.error('Failed to convert base64 to file');
      this.resetFile();
    }
  }

  uploadFile(file: File): void {
    const formData: FormData = new FormData();
    formData.append('name', file.name);
    formData.append('file', file);
    this.service.uploadConsultantLogo(formData).subscribe(res => {
      if (res.type === 4) {
        this.updateConsultantLogo(res.body.url, res.body.cid);
      }
    });
  }

  updateConsultantLogo(url: string, cid: string): void {
    this.consultantLogo = url;
    this.data.logo = this.consultantLogo;
    this.consultantImage = this.data.logo;
    this.logoCid = cid;
    this.logoLoader = false;
  }

  resetFile(): void {
    this.file = null;
    this.logoLoader = false;
  }

  base64ToFile(data: string, filename: string): File | null {
    if (!data) {
      console.error('No data provided to base64ToFile');
      return null;
    }
    const arr = data.split(',');
    if (arr.length < 2) {
      console.error('Invalid base64 data:', data);
      return null;
    }
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch) {
      console.error('Invalid MIME type in base64 data:', arr[0]);
      return null;
    }
    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    const u8arr = new Uint8Array(bstr.length);
    for (let i = 0; i < bstr.length; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }
    return new File([u8arr], filename, {type: mime});
  }

  handleDialogCloseWithoutResult(): void {
    console.error('Dialog closed without result');
    this.resetFile();
  }


  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    setTimeout(() => {
      this.dragOver = true;
    }, 2000);
  }

  onDragEnter(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    setTimeout(() => {
      this.dragOver = false;
    }, 2000);
  }

  close() {
    const isDirtyForm = Object.values(this.childFormUpdates).some(value => value === true);
    if (isDirtyForm) {
      const confirmationBox = this.dialog.open(PopUpComponent, {
        data: {
          message: 'Do you want to close this without saving',
          type: 'confirmation'
        }
      });
      confirmationBox.afterClosed().subscribe((res) => {
        if (res) {
          this.dialogRef.close();
        }
      });
    } else {
      this.dialogRef.close();
    }
  }

  setFirstName(e: any) {
    this.firstName = e
  }

  updatedPayload() {
    let newPayload = this.consultantForm.value;
    let selectedSkills: number[] = [];
    newPayload = {...newPayload, skills: selectedSkills};
    return newPayload;
  }

  getFormValidationErrors(): string {
    let error = '';
    Object.keys(this.consultantForm.controls).forEach(key => {
      const controlErrors = this.consultantForm.get(key)?.errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          error = error + key + ', ';
        });
      }
    });
    return error;
  }

  addCandidate(): void {
    let input: CreateCustomer = this.consultantForm?.value;
    input.logoCid = this.logoCid;
    this.consultantError = '';

    // @ts-ignore
    const fullName = this.consultantForm.get('firstName').value ?? '';
    const fullNameArray = fullName.split(' ');

    let firstName = '';
    let middleName = '';
    let lastName = '';

    if (fullNameArray.length === 1) {
      firstName = fullNameArray[0];
    } else if (fullNameArray.length === 2) {
      firstName = fullNameArray[0];
      lastName = fullNameArray[1];
    } else if (fullNameArray.length === 3) {
      firstName = fullNameArray[0];
      middleName = fullNameArray[1];
      lastName = fullNameArray[2];
    } else if (fullNameArray.length > 3) {
      firstName = fullNameArray[0];
      middleName = fullNameArray[1];
      lastName = fullNameArray.slice(2, 3).join(' ');
      lastName += ' ' + fullNameArray.slice(3).join(' ');
    }
    if (!firstName || !firstName.trim()) {
      this.showloader = false;
      this.toastr.info('First name is required.', 'Error');
      return;
    }
    this.showloader = true;

    if (this.consultantForm.invalid) {
      this.showloader = false;
      this.consultantError = 'Error in ' + this.getFormValidationErrors() + '. See console for details';
      return;
    } else {
      this.service.addNewConsultant({...input, firstName, middleName, lastName}).subscribe({
        next: res => {
          this.loading = false;
          this.data = res;
          this.firstName = res.firstName;
          this.type = 'create';
          this.dialogRef.close({id: res.id});
          this.showloader = false;
        },
        error: (e) => {
          if (e.error) {
            this.loading = false;
            this.dialogRef.disableClose;
            this.showloader = false;
          }
        }
      });
    }
  }

  delete(): void {
    this.data.logo = '';
    this.data.profilePicture = '';
    this.consultantImage = '';
    this.consultantLogo = null;
    this.logoCid = '';
  }

  getConsultantImage(): string {
    if (this.consultantImage) {
      return this.consultantImage;
    }
    if (this.consultantDT?.profilePicture) {
      return this.consultantDT.profilePicture;
    }
    return this.consultantDT?.gender === 'Female'
      ? './assets/images/femaleDefault.jpg'
      : './assets/images/maleDefault.jpg';
  }

}
